import { render, staticRenderFns } from "./Basf02.vue?vue&type=template&id=e3031bc4&scoped=true&"
import script from "./Basf02.vue?vue&type=script&lang=js&"
export * from "./Basf02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3031bc4",
  null
  
)

export default component.exports